// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface SuiteTree
 */
export interface SuiteTree {
  /**
   *
   * @type {number}
   * @memberof SuiteTree
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof SuiteTree
   */
  title: string;
  /**
   * No. of child suites in this suite
   * @type {number}
   * @memberof SuiteTree
   */
  suitecount?: number;
  /**
   * Suite created by
   * @type {number}
   * @memberof SuiteTree
   */
  createdBy?: number;
  /**
   * No. of test cases in this suite
   * @type {number}
   * @memberof SuiteTree
   */
  testcasecount: number;
  /**
   * No. of test cases in this suite (including child suites)
   * @type {number}
   * @memberof SuiteTree
   */
  alltestcasecount?: number;
  /**
   *
   * @type {Array<SuiteTree>}
   * @memberof SuiteTree
   */
  children: Array<SuiteTree>;
  /**
   * True when the suite is managed by BDD sync from a feature file in Git.
   * @type {boolean}
   * @memberof SuiteTree
   */
  readonly isBddManaged?: boolean;
  /**
   * Will be true only for links
   * @type {boolean}
   * @memberof SuiteTree
   */
  isReference?: boolean;
  /**
   * Only for links - source entity ID
   * @type {number}
   * @memberof SuiteTree
   */
  sourceId?: number;
  /**
   * Only for links - source Project ID
   * @type {number}
   * @memberof SuiteTree
   */
  sourceProject?: number;
  /**
   * Will be true only for top level link suite
   * @type {boolean}
   * @memberof SuiteTree
   */
  isMainLink?: boolean;
}

export function SuiteTreeFromJSON(json: any): SuiteTree {
  return {
    id: json["id"],
    title: json["title"],
    suitecount: !exists(json, "suitecount") ? undefined : json["suitecount"],
    createdBy: !exists(json, "created_by") ? undefined : json["created_by"],
    testcasecount: json["testcasecount"],
    alltestcasecount: !exists(json, "alltestcasecount")
      ? undefined
      : json["alltestcasecount"],
    children: (json["children"] as Array<any>).map(SuiteTreeFromJSON),
    isBddManaged: !exists(json, "is_bdd_managed")
      ? undefined
      : json["is_bdd_managed"],
    isReference: !exists(json, "is_reference")
      ? undefined
      : json["is_reference"],
    sourceId: !exists(json, "source_id") ? undefined : json["source_id"],
    sourceProject: !exists(json, "source_project")
      ? undefined
      : json["source_project"],
    isMainLink: !exists(json, "is_main_link")
      ? undefined
      : json["is_main_link"],
  };
}

export function SuiteTreeToJSON(value?: SuiteTree): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    title: value.title,
    suitecount: value.suitecount,
    created_by: value.createdBy,
    testcasecount: value.testcasecount,
    alltestcasecount: value.alltestcasecount,
    children: (value.children as Array<any>).map(SuiteTreeToJSON),
    is_reference: value.isReference,
    source_id: value.sourceId,
    source_project: value.sourceProject,
    is_main_link: value.isMainLink,
  };
}
